import { CalendarStyles } from '@microsoft/fast-components';
import { CalendarTitleTemplate, } from '@microsoft/fast-foundation';
import { css, html } from '@microsoft/fast-element';
import { Calendar, calendarTemplate } from '@microsoft/fast-foundation';
import { CalendarComponent } from './Calendar';
import styles from './Calendar.styles.scss';
import { SVG_CHEVRON_LEFT_OUTLINED, SVG_CHEVRON_RIGHT_OUTLINED } from '@getgo/chameleon-icons';
const newCalendarTemplate = (context, definition) => {
    return html ` <template
    @dateselected="${(el, ctx) => el.handleClickListener(ctx.event)}"
    @change="${(el, ctx) => el.handleChangeListener(ctx.event)}"
  >
    <header>
      <chameleon-icon-button
        id="previous-month"
        variant="neutral"
        size="small"
        aria-label="previous month"
        @click="${(el) => el.goToPreviousMonthListener(undefined)}"
        ><chameleon-svg>${SVG_CHEVRON_LEFT_OUTLINED}</chameleon-svg></chameleon-icon-button
      >
      ${CalendarTitleTemplate}
      <chameleon-button variant="tertiary" size="small" id="today-selector" @click="${(el) => el.todayButtonListener()}"
        ><slot>
          ${(x) => {
        var _a, _b;
        return new Intl.RelativeTimeFormat((_b = (_a = x.locale) !== null && _a !== void 0 ? _a : document.documentElement.lang) !== null && _b !== void 0 ? _b : 'en-US', {
            numeric: 'auto',
        }).format(0, 'day');
    }}
        </slot>
      </chameleon-button>
      <chameleon-icon-button
        id="next-month"
        variant="neutral"
        size="small"
        aria-label="next month"
        @click="${(el) => el.goToNextMonthListener(undefined)}"
        ><chameleon-svg>${SVG_CHEVRON_RIGHT_OUTLINED}</chameleon-svg></chameleon-icon-button
      >
    </header>
    <div
      id="calendar-container"
      part="calendar-container"
      aria-label="calendar container"
      tabindex="0"
      @keydown="${(el, { event }) => el.handleCalendarKeydownListener(event)}"
    >
      ${calendarTemplate(context, definition)}
    </div>
  </template>`;
};
export const chameleonCalendar = CalendarComponent.compose({
    baseName: 'calendar',
    baseClass: Calendar,
    template: newCalendarTemplate,
    styles: () => css `
    ${CalendarStyles}
    ${styles}
  `,
    shadowOptions: {
        delegatesFocus: true,
    },
});
